import axios from 'axios';

const getStartExportChat = async (
  channelId: string,
  abortSignal?: AbortSignal,
): Promise<string> => {
  try {
    const url = `/streamchat/export/start?channelId=${encodeURIComponent(channelId)}`;

    const { data } = await axios.get<string>(url, { signal: abortSignal });

    return data;
  } catch (error) {
    console.error(`Error starting export with channelId: ${channelId}`, error);
    throw error;
  }
};

export default getStartExportChat;
